import * as EcdsaMultikey from '@digitalbazaar/ecdsa-multikey';
import { VerificationType } from '../../lib/types';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const generateEcdsaSd2023KeyPair = /* @__PURE__ */ __name(async () => {
  const ecdsaKeyPair = await EcdsaMultikey.generate({
    curve: "P-256"
  });
  const exportedKeys = await ecdsaKeyPair.export({
    publicKey: true,
    secretKey: true
  });
  const keyPair = {
    type: VerificationType.Multikey,
    secretKeyMultibase: exportedKeys.secretKeyMultibase,
    publicKeyMultibase: exportedKeys.publicKeyMultibase
  };
  return keyPair;
}, "generateEcdsaSd2023KeyPair");

export { generateEcdsaSd2023KeyPair };
